import { bootstrapApplication } from '@angular/platform-browser';
import { buildAppConfig } from './app/app.config';
import { App } from './app/app';
import { loadRuntimeConfig } from './app/runtime-config';

// The providers (Keycloak url/realm, the tracer URL the interceptors match)
// read the runtime config, so it must be loaded before they are built.
loadRuntimeConfig()
  .then(() => bootstrapApplication(App, buildAppConfig()))
  .catch((err) => console.error(err));
